import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Typography } from '@mui/material';
import { Icon } from 'antd';
import { PropTypes } from 'prop-types';

import { ModalSto } from 'components/sto';

const TooltipChangeNameModal = (props) => (
    <ModalSto okText="general.ok" onOk={props.onOk} visible={props.visible}>
        <React.Fragment>
            <Box className="tooltip-container">
                <Icon className="popup-hint" id="info-icon" type="info-circle" />
                <Box>
                    <Typography className="tooltip-title">
                        <FormattedMessage id="pages.profile.tooltip.title" />
                    </Typography>
                    <Typography className="tooltip-text">
                        <FormattedMessage id="pages.profile.tooltip.contact" />
                    </Typography>
                    <Typography className="tooltip-text italic">
                        <FormattedMessage id="pages.profile.tooltip.contact.hours" />
                    </Typography>
                </Box>
            </Box>
        </React.Fragment>
    </ModalSto>
);

TooltipChangeNameModal.propTypes = {
    onOk: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
};

export default TooltipChangeNameModal;
